import { MenuItem } from "@/lib/types"
import { RestaurantItem } from "@/lib/types/order-detail"

import {
  CartCustomization,
  CartCustomizationOption,
  CartReconciliationResult,
  DishMapRecord,
} from "../types/cart"

interface CustomizeOption {
  id: string
  quantity: number
  price: number
}

const reconcileCustomizations = (
  item: RestaurantItem,
  menuItem: MenuItem
): CartCustomization[] => {
  return (item.customizes || [])
    .filter((customize) => {
      const customizeId = customize.id
      const currentCustomize = menuItem.customize_item.find(
        (c) => c.customize_id.toString() === customizeId
      )
      return currentCustomize?.customize_active ?? false
    })
    .map((customize) => {
      const customizeId = customize.id
      const currentCustomize = menuItem.customize_item.find(
        (c) => c.customize_id.toString() === customizeId
      )

      const options = (customize.options || [])
        .filter((option: CustomizeOption) => {
          const currentOption = currentCustomize?.customize_options.find(
            (o) => o.customize_option_id.toString() === option.id
          )
          return currentOption?.customize_option_active ?? false
        })
        .map((option: CustomizeOption): CartCustomizationOption => {
          const currentOption = currentCustomize?.customize_options.find(
            (o) => o.customize_option_id.toString() === option.id
          )
          return {
            id: option.id,
            quantity: option.quantity,
            price: option.price,
            name: currentOption?.customize_option_name || "",
          }
        })

      return {
        id: customize.id,
        name: currentCustomize?.customize_item_name || "",
        options,
      }
    })
}

export const reconcileCartWithDishMap = (
  items: RestaurantItem[],
  dishMap: DishMapRecord
): CartReconciliationResult[] => {
  return items
    .map((item): CartReconciliationResult | null => {
      const id = item.restaurant_item_id || 0
      const menuItem = dishMap[id]

      if (!menuItem) {
        return null
      }

      return {
        item_id: id.toString(),
        quantity: item.item_quantity || item.quantity || 0,
        price: menuItem.price,
        note: item.note || "",
        customizes: reconcileCustomizations(item, menuItem),
      }
    })
    .filter(
      (item): item is CartReconciliationResult =>
        item !== null && item.quantity > 0
    )
}
